import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import * as React from 'react';

import * as constants from '@app/constants';
import Icon from './icon.component';

const defaultProps: DatePickerProps = {
	format: constants.datePickerFormat,
	inputVariant: 'outlined',
	fullWidth: true,
	leftArrowIcon: <Icon name='chevron-left' className='icon-dimension-square' />,
	rightArrowIcon: <Icon name='chevron-right' className='icon-dimension-square' />,
	onChange: () => null,
	value: '',
};

const CustomDatePicker: React.FunctionComponent<DatePickerProps> = (props) => {
	return <DatePicker {...props} />;
};

CustomDatePicker.defaultProps = defaultProps;

export default CustomDatePicker;



// WEBPACK FOOTER //
// ./src/components/shared/custom-date-picker.component.tsx